import { Trans, useTranslation } from 'next-i18next/pages';
import React from 'react';

import {
  MAX_DISTANCE_LIMIT_IN_KM,
  MAX_DISTANCE_LIMIT_IN_KM_EXTENDED,
  MAX_TRANSPARENT_DISTANCE_IN_KM,
} from '@pflegia/types/common/job-board/constants';

import HighlightedText from '@shared/components/HighlightedText';

interface JobBoardHeadingProps {
  hasExtendedPositions: boolean;
  heading?: string | null;
  headingKey: string;
  isTransparentJobBoard: boolean;
  jobTitle?: string;
  location?: string;
  numberOfJobs?: number;
  expandedRadiusKm?: number;
}

export const getDistanceLimit = (isTransparentJobBoard: boolean, hasExtendedPositions: boolean, expandedRadiusKm?: number): number => {
  if (expandedRadiusKm) return expandedRadiusKm;
  if (isTransparentJobBoard && hasExtendedPositions) return MAX_DISTANCE_LIMIT_IN_KM_EXTENDED;
  if (isTransparentJobBoard) return MAX_TRANSPARENT_DISTANCE_IN_KM;
  return MAX_DISTANCE_LIMIT_IN_KM;
};

const JobBoardHeading: React.FC<JobBoardHeadingProps> = ({
  hasExtendedPositions,
  heading,
  headingKey,
  isTransparentJobBoard,
  jobTitle,
  location,
  numberOfJobs,
  expandedRadiusKm,
}) => {
  const { t } = useTranslation('jobBoard', { keyPrefix: 'seo' });
  const distanceLimitInKm = getDistanceLimit(isTransparentJobBoard, hasExtendedPositions, expandedRadiusKm);

  return (
    <h1 className='mt-12 text-3xl font-medium wrap-break-word'>
      {heading ? (
        <HighlightedText text={heading} />
      ) : (
        <Trans
          i18nKey={headingKey}
          t={t}
          components={{ span: <span className='text-primary' /> }}
          values={{
            NUMBER_OF_JOBS: numberOfJobs ?? 0,
            JOB_TITLE: jobTitle,
            LOCATION: location || t('locationFallback'),
            DISTANCE_LIMIT_IN_KM: distanceLimitInKm,
          }}
        />
      )}
    </h1>
  );
};

export default JobBoardHeading;
